import React from "react";
import { Reveal, Overline } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { PROGRAMS } from "../lib/data";

const CHART = "https://images.unsplash.com/photo-1745509267699-1b1db256601e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const Programs = () => (
  <section id="programs" data-testid="programs" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36">
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
      <Reveal>
        <Overline>Strategies & Programs</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05] max-w-2xl">
          Capital for every kind of edge.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="text-mute max-w-sm leading-relaxed">
          Whether you trade on instinct or on models, we have a mandate — and the balance sheet — built for how you work.
        </p>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
      <Reveal className="md:col-span-8" delay={0.05}>
        <div className="relative h-full min-h-[280px] border border-line overflow-hidden group">
          <img src={CHART} alt="Market strategy" className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink to-transparent" />
          <div className="relative p-8 sm:p-10 h-full flex flex-col justify-between">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-brass">{PROGRAMS[0].tag}</span>
            <div>
              <h3 className="font-serif text-3xl sm:text-4xl text-bone">{PROGRAMS[0].title}</h3>
              <p className="text-mute mt-3 max-w-lg leading-relaxed">{PROGRAMS[0].body}</p>
            </div>
          </div>
        </div>
      </Reveal>

      {PROGRAMS.slice(1).map((p, i) => (
        <Reveal key={p.title} className={i === 0 ? "md:col-span-4" : "md:col-span-12"} delay={0.1 + i * 0.05}>
          <div className="h-full border border-line bg-surface p-8 hover:bg-surface2 hover:border-brass/40 transition-colors duration-500 group flex flex-col justify-between min-h-[240px]">
            <div className="flex items-start justify-between">
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-brass">{p.tag}</span>
              <ArrowUpRight size={18} className="text-mute group-hover:text-brass group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
            </div>
            <div className="mt-8">
              <h3 className="font-serif text-2xl sm:text-3xl text-bone">{p.title}</h3>
              <p className="text-mute text-sm mt-3 leading-relaxed">{p.body}</p>
              <div className="mt-5 font-mono"><span className="text-xl text-bone">{p.metric}</span> <span className="text-[10px] uppercase tracking-[0.2em] text-mute ml-2">{p.metricLabel}</span></div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
